import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../../common/ui/Loader';
import Department from './Department';
import Validator from '../../../../common/forms/Validator';
import ErrorMessage from '../../../../common/forms/ErrorMessage';

export default class Departments extends Validator {
  state = {
    isLoading: true,
    isLoadingSubmit: false,
    name: ''
  };

  validationRules = { name: { required: true } };

  _setDataLoaded = () => this.setState({ isLoading: false });

  handleChange = event => this.setState({ [event.target.name]: event.target.value });

  createDepartment = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      this.setState({ isLoadingSubmit: true });
      const { company, createCompanyDepartment } = this.props;

      createCompanyDepartment({
        company_id: company.id,
        name: this.state.name
      }).then(this._resetState);
    }
  };

  _resetState = () => this.setState({ isLoadingSubmit: false, name: '' });

  componentDidMount () {
    this.props.getCompanyDepartments(this.props.company.id)
      .then(this._setDataLoaded);
  }

  render () {
    if (this.state.isLoading) {
      return <Loader />;
    }

    const { company: { departments }, editCompanyDepartment } = this.props;
    const { name, isLoadingSubmit } = this.state;

    return (
      <div>
        <form onSubmit={this.createDepartment} className='d-flex'>
          <input id='department' value={name} name='name' onChange={this.handleChange} className='input' placeholder='Enter new department name' />
          <button disabled={isLoadingSubmit} className='button button-primary'>Add</button>
        </form>

        <ErrorMessage errorText={this.validationErrors.name} />

        <div className='list-group mt-3'>
          {departments.length ? (
            departments.map(dept => (
              <Department editDepartment={editCompanyDepartment} department={dept} key={dept.id} />
            ))
          ) : (
            <p className='list-group-item'>No departments found</p>
          )}
        </div>
      </div>
    );
  }
}

Departments.propTypes = {
  company: PropTypes.object,
  editCompanyDepartment: PropTypes.func,
  createCompanyDepartment: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Departments/index.js